export interface ISingleProduct {
  brands: any;
  desireid: number;
  userid?: number;
  // brand_id?: number;
  source_id?: number;
  title?: string;
  description?: string;
  short_description?: string;
  price?: string;
  url?: string;
  originalUrl?: string;
  image?: string;
  dateCreated: string;
  interestid: any;
  deactivated: boolean;
  sortorder: any;
  views: number;
  shares: number;
  searches: number;
  featured: any;
  what_text: string;
  who_text: string;
  why_text: string;
  reviews: any[];
  embeds: any[];
  productVideos: any[];
  // Number of PDP URLs (desires_pdp_urls) on the product — list endpoints attach it.
  pdp_url_count?: number;
  // How many of those pages the last PDP analysis found one of our videos on.
  placed_count?: number;
  // Latest ready PDP score for this brand('s network), averaged across the
  // product's active PDPs — the brand products endpoint attaches it.
  pdp_score?: number | null;
  // The viewed brand's own catalog category for this product (its crawled
  // tree — the "Sam's Club Category" column).
  rmn_category?: { id: number; name: string } | null;
  // Latest ready audit run across the product's network PDP URLs — enough
  // to fetch the stored audit and build the PDF.
  latest_report?: {
    score_id: number;
    pdp_url_id: number;
    pdp_url: string;
    scored_at: string;
  } | null;
  // True while a scoring report is in flight on one of those PDPs (fresh
  // pending attempt) — the list's Run report button disables on it.
  pdp_report_running?: boolean;
  // Consumer Voice (lib/pdpUrlCounts attachConsumerVoice): latest ready
  // product analysis for this brand scope, and whether one is in flight.
  cv_score?: number | null;
  cv_subscores?: { sentiment: number | null; advocacy: number | null; objection_severity: number | null; confidence: number | null } | null;
  cv_latest?: { id: number; scored_at: string } | null;
  // AI Presence (server: pdpUrlCounts.attachAiPresence).
  aip_score?: number | null;
  aip_subscores?: import('../../../../types/aiPresence').AipSubscores | null;
  aip_latest?: { id: number; scored_at: string } | null;
  aip_running?: boolean;
  cv_running?: boolean;
  // Comma-separated subreddit hints (product settings > Consumer Voice).
  cv_subreddits?: string | null;
  // Returns estimate (product settings > General): Autopilot's
  // reduce-returns metric is returns / units.
  estimated_annual_units?: number | null;
  estimated_annual_returns?: number | null;
  product_categories?: {
    id: number;
    name: string;
    parent_id: number | null;
    external_id?: string | null;
  }[];
}

export const truncateStyle = (index: number) => ({
  "-webkit-box-orient": "vertical",
  overflow: "hidden",
  display: "-webkit-box",
  "-webkit-line-clamp": `${index}`,
});
